module.exports = __webpack_public_path__ + "static/img/agreement.d495221.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/merchants-entering/pc/agreement.png
// module id = ba7s
// module chunks = 0